import type { ShipConfirmationTracker } from '../api/types'
import { EstimateHistoryPanel } from './EstimateHistoryPanel'
import { SplitRowsPanel } from './SplitRowsPanel'

/**
 * Expanded-row content shared by the flat table and the per-PO drawer:
 * the split breakdown for a split line, and the estimate history for any
 * line with logged estimates.
 */
export function LineExpandedPanel({ tracker }: { tracker: ShipConfirmationTracker }) {
  return (
    <>
      {tracker.open_split_count > 0 ? <SplitRowsPanel tracker={tracker} /> : null}
      {(tracker.estimate_count ?? 0) > 0 ? <EstimateHistoryPanel tracker={tracker} /> : null}
    </>
  )
}
